export enum AIEmailTemplateStatus {
  initial = 'initial',
  scraped = 'scraped',
  failed = 'failed',
}

export type AIEmailTemplate = {
  status: AIEmailTemplateStatus;
  createdAt: string;
  updatedAt: string;
  emailTemplate: null | { body: string | null; subject: string | null };
};
